// extracted by mini-css-extract-plugin
export var checkbox = "Contact-module--checkbox--IGpbh";